import React, { useState } from 'react';

const FaultySensorCell = ({ lines, visibleCount = 2 }) => {
    const [expanded, setExpanded] = useState(false);

    if (!lines || lines.length === 0) {
        return <span>---</span>;
    }

    const hasMore = lines.length > visibleCount;
    const displayLines = expanded ? lines : lines.slice(0, visibleCount);

    return (
        <div style={{ textAlign: 'left' }}>
            {displayLines.map((line, idx) => (
                <div
                    key={idx}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '220px',
                    }}
                    title={line}>
                    {line}
                </div>
            ))}

            {hasMore && (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setExpanded((prev) => !prev);
                    }}
                    style={{ fontSize: '12px', color: '#F9B74C', fontWeight: 600, textDecoration: 'underline' }}>
                    {expanded ? 'Show less' : `+${lines.length - visibleCount} more`}
                </a>
            )}
        </div>
    );
};

export default FaultySensorCell;
